/*
 * Purpose : Footer component
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React from 'react';
import { MDBContainer, MDBFooter } from "mdbreact";

import './footer.css';

const footer = () => {
    return(   
        <MDBFooter>
            <div className="footer-copyright text-center py-3" style={{background: "linear-gradient(to bottom, #E8E8E8, #fff)", marginTop:"10px"}}>
                <MDBContainer fluid>
                    © Globalfoundries. All rights reserved
                </MDBContainer>
            </div>
        </MDBFooter>
    );
}
export default footer;